export default {"src":"/_next/static/media/WhatsappRounded.9a90c5b4.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};